import { render, staticRenderFns } from "./SubjectSelect.vue?vue&type=template&id=0474ac1e&scoped=true&"
import script from "./SubjectSelect.vue?vue&type=script&lang=ts&"
export * from "./SubjectSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474ac1e",
  null
  
)

export default component.exports